import { create } from "zustand";

interface TokenFilterStoreType {
  /**
   * Whether to show only bridgeable tokens (hide unbridgeable ones)
   * Default: true (show bridgeable only)
   */
  showOnlyBridgeableTokens: boolean;

  /**
   * Toggle the filter state
   */
  toggleBridgeableFilter: () => void;

  /**
   * Set the filter state explicitly
   */
  setShowOnlyBridgeableTokens: (show: boolean) => void;
}

export const useTokenFilterStore = create<TokenFilterStoreType>((set) => ({
  showOnlyBridgeableTokens: true,

  toggleBridgeableFilter: () =>
    set((state) => ({
      showOnlyBridgeableTokens: !state.showOnlyBridgeableTokens
    })),

  setShowOnlyBridgeableTokens: (show: boolean) =>
    set({ showOnlyBridgeableTokens: show }),
}));
